'use client';

import { useEffect } from 'react';
import { apiFetch } from '@/utils/api';

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    // send details to server logs
    try {
      apiFetch('/api/client-log', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          type: 'global-error',
          message: error && error.message,
          stack: error && error.stack,
          digest: error && error.digest,
          url: typeof window !== 'undefined' ? window.location.href : '',
          ua: typeof navigator !== 'undefined' ? navigator.userAgent : '',
        }),
      }).catch(() => {});
      // still show in browser console for you
      // eslint-disable-next-line no-console
      console.error('GlobalError caught:', error);
    } catch {}
  }, [error]);

  return (
    <html>
      <body style={{ fontFamily: 'system-ui', padding: 24 }}>
        <h1>Something went wrong</h1>
        <p>Please try again.</p>
        <button
          onClick={reset}
          style={{ padding: '8px 12px', border: '1px solid #ccc', borderRadius: 6 }}
        >
          Try again
        </button>
      </body>
    </html>
  );
}
